<script setup lang="ts">
    import { onMounted, ref, watch } from 'vue';

    type Props = {
        activeTags: string[];
        displayShowOtherOption?: boolean;
        showOther?: boolean;
        allTags: string[];
    };

    const props = withDefaults(defineProps<Props>(), {
        displayShowOtherOption: false,
        showOther: false
    });

    const emit = defineEmits<{
        'update:tags': [payload: string[]];
        'update:show-other': [payload: boolean];
    }>();

    const selected = ref<string[]>([]);
    const currentShowOther = ref<boolean>(false);

    watch(
        () => props.activeTags,
        (v) => {
            selected.value = v ?? [];
        },
        { immediate: true }
    );

    watch(
        () => props.showOther,
        (v) => {
            currentShowOther.value = !!v;
        },
        { immediate: true }
    );

    onMounted(async () => {
        selected.value = props.activeTags ?? [];
        currentShowOther.value = !!props.showOther;
    });

    function selectTag(tag: string) {
        if (selected.value.includes(tag)) {
            selected.value = selected.value.filter((t) => t !== tag);
        } else {
            selected.value = selected.value.concat([tag]);
        }
        emit('update:tags', selected.value);
    }

    function selectShowOther() {
        emit('update:show-other', currentShowOther.value);
    }
</script>

<template>
    <div
        class="columns library-group-container">
        <div
            v-for="(tag, idx) in allTags"
            :key="idx"
            class="library-group-item">
            <p class="control is-pulled-left">
                <b-checkbox
                    :model-value="selected.includes(tag)"
                    @update:model-value="selectTag(tag)">
                    {{ tag }}
                </b-checkbox>
            </p>
        </div>
        <div v-if="displayShowOtherOption">
            <b-checkbox
                v-model="currentShowOther"
                @update:model-value="selectShowOther">
                Ungrouped libraries
            </b-checkbox>
        </div>
    </div>
</template>
<style scoped>
    .library-group-container {
        padding: 5px;
        display: flex;
        flex-flow: column wrap;
        justify-content: flex-start;
        overflow-x: auto;
        width:100%;
        height:100%;
    }
    .library-group-item {
        flex-basis: 20px;
        flex-grow: 0;
        flex-shrink: 0;
        height:20px;
    }
</style>
